import { hotThreads, hotRank } from "@/mocks/gossipData";
import Reveal from "./Reveal";

export default function HotThreads() {
  return (
    <section id="community" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-accent-600">
                <span className="inline-block h-1.5 w-1.5 rounded-full bg-primary-500" />
                评论区才是主战场
              </p>
              <h2 className="mt-2 text-2xl font-extrabold tracking-tight text-foreground-950 md:text-[28px]">
                社区热议中 · 进来插一嘴
              </h2>
              <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
                每条新瓜下面都有人在站队、在复盘、在抬杠。挑一个你站得住的话题，加入讨论。
              </p>
            </div>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-3">
          {/* discussion threads */}
          <div className="flex flex-col gap-4 lg:col-span-2">
            {hotThreads.map((t, i) => (
              <Reveal key={t.title} delay={i * 60}>
                <div className="flex gap-3 rounded-2xl border border-background-200 bg-background-50 p-4 md:p-5">
                  <span
                    className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${
                      i % 2 === 0 ? "bg-primary-100 text-primary-700" : "bg-accent-100 text-accent-700"
                    }`}
                  >
                    <i className={`${i % 2 === 0 ? "ri-chat-3-fill" : "ri-question-line"} text-base`} />
                  </span>
                  <div className="min-w-0 flex-1">
                    <h3 className="text-[15px] font-bold leading-snug text-foreground-950">{t.title}</h3>
                    <p className="mt-1 text-xs text-foreground-500">{t.meta}</p>
                    <div className="mt-2.5 flex flex-wrap items-center gap-2">
                      <button
                        type="button"
                        className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-3.5 py-1.5 text-xs font-medium text-background-50 hover:bg-primary-600"
                      >
                        <i className="ri-chat-smile-3-fill text-xs" />
                        加入讨论
                      </button>
                      <span className="flex items-center gap-1 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1.5 text-xs text-secondary-700">
                        <i className="ri-team-fill text-xs" />
                        {t.people}
                      </span>
                      <span className="flex items-center gap-1 whitespace-nowrap rounded-full bg-background-100 px-3 py-1.5 text-xs text-foreground-600">
                        <i className="ri-thumb-up-fill text-xs text-accent-600" />
                        {t.votes.toLocaleString()} 票
                      </span>
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          {/* hot rank */}
          <Reveal delay={120}>
            <div className="flex h-full flex-col rounded-2xl border border-background-200 bg-background-100 p-5">
              <div className="flex items-center justify-between">
                <h3 className="flex items-center gap-2 text-sm font-bold text-foreground-950">
                  <i className="ri-fire-fill text-accent-500" />
                  今日热度 TOP5
                </h3>
                <span className="text-xs text-foreground-500">每小时更新</span>
              </div>
              <div className="mt-4 flex flex-1 flex-col justify-between gap-3">
                {hotRank.map((r) => (
                  <a href="#community" key={r.rank} className="group flex items-center gap-3">
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg text-sm font-extrabold ${
                        r.rank === 1
                          ? "bg-accent-500 text-background-50"
                          : r.rank === 2
                            ? "bg-secondary-500 text-background-50"
                            : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      {r.rank}
                    </span>
                    <p className="min-w-0 flex-1 truncate text-sm text-foreground-700 group-hover:text-primary-600">
                      {r.text}
                    </p>
                    <span className="text-xs font-semibold text-foreground-500">{r.heat}</span>
                  </a>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}